import { render, staticRenderFns } from "./copy-to-clipboard-trigger.vue?vue&type=template&id=3d694d6d"
import script from "./copy-to-clipboard-trigger.vue?vue&type=script&lang=js"
export * from "./copy-to-clipboard-trigger.vue?vue&type=script&lang=js"
import style0 from "./copy-to-clipboard-trigger.vue?vue&type=style&index=0&id=3d694d6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports